/**
 * Set up routing for all Metric views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

// import global components
import AuthoringLayout from '../admin/components/AuthoringLayout.js.jsx';
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import metric views
import CreateMetric from './views/CreateMetric.js.jsx';
import MetricList from './views/MetricList.js.jsx';
import SingleMetric from './views/SingleMetric.js.jsx';
import UpdateMetric from './views/UpdateMetric.js.jsx';

class MetricAdminRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    let singleMetricUpdatePath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/update'), 0);
    return (
      <Switch>
        <YTRoute
          breadcrumbs={[{display:'All metrics', path:null}]}
          component={MetricList}
          exact
          role="admin"
          path="/admin/authoring/metrics"
        />
        <YTRoute
          breadcrumbs={[{display:'All metrics', path:'/admin/authoring/metrics'}, {display:'New metric', path:null}]}
          component={CreateMetric}
          exact
          role="admin"
          path="/admin/authoring/metrics/new"
        />
        <YTRoute
          breadcrumbs={[{display:'All metrics', path:'/admin/authoring/metrics'}, {display:'Metric details', path:null}]}
          component={SingleMetric}
          exact
          role="admin"
          path="/admin/authoring/metrics/:metricId"
        />
        <YTRoute
          breadcrumbs={[{display:'All metrics', path:'/admin/authoring/metrics'}, {display:'Metric details', path:singleMetricUpdatePath}, {display:'Update', path:null}]}
          component={UpdateMetric}
          exact
          role="admin"
          path="/admin/authoring/metrics/:metricId/update"
        />
      </Switch>
    )
  }
}

export default withRouter(MetricAdminRouter);



// WEBPACK FOOTER //
// modules/metric/MetricAdminRouter.js.jsx